import { render, staticRenderFns } from "./CIntroduction.vue?vue&type=template&id=27652829&scoped=true&"
import script from "./CIntroduction.vue?vue&type=script&lang=js&"
export * from "./CIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./CIntroduction.vue?vue&type=style&index=0&id=27652829&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27652829",
  null
  
)

export default component.exports